module.exports = __webpack_public_path__ + "static/img/MAHMOUD-TAHA.0fcf7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MAHMOUD-TAHA.jpg
// module id = Ekg9
// module chunks = 0